export enum ProjectInstallationType {
  OnPremiseOnly = 'onPremiseOnly',
  CloudOnly = 'cloudOnly',
  AllInOne = 'allInOne',
}

export interface IProjectConfigUrls {
  apiUrl: string;
  streamApiUrl: string;
  wsApiUrlDeprecated: string;
  bffUrl: string;
  wsApiUrl: string;
  publicUrl: string;
  bffCallsUrl: string;
  liveKitCallsUrl: string;
  routerUrl: string;
  unauthorizedUrl: string;
}

export enum ProjectName {
  Cowork = 'cowork',
  Gemteam = 'gemteam',
}

export enum EnvName {
  Local = 'local',
  Stage = 'stage',
  Prod = 'prod',
  Preprod = 'preprod',
}

export enum AppLanguage {
  Ru = 'ru-RU',
  En = 'en-US',
  Ar = 'ar-AE',
}

export type TMobileAppName =
  | 'ruStore'
  | 'appStore'
  | 'googlePlay'
  | 'galaxyStore'
  | 'appGallery'
  | 'miAppMall';

export interface IProjectConfig {
  urls: IProjectConfigUrls;
  mobileApps: { name: TMobileAppName; url: string }[];
  appLinkProtocol: string;
  installationType: ProjectInstallationType;
  features: {
    bugsnag: boolean;
    unionCall: boolean;
    spaces: boolean;
    catalog: boolean;
    newsfeed: boolean;
    hub: boolean;
    marketplace: boolean;
    article: boolean;
    deleteForMe: boolean;
    voiceTranscription: boolean;
    messageTranslate: boolean;
    bot: boolean;
    streams: boolean;
    flexibleCall: boolean;
    channelCategory: boolean;
    banUser: boolean;
    scheduledMessages: boolean;
    threads: boolean;
    locationMessages: boolean;
    reports: boolean;
    onboarding: boolean;
    permissionsGroup: boolean;
    permissionsSpace: boolean;
    userDeepLink: boolean;
    scheduledCall: boolean;
    userGifts: boolean;
    verifiedBadge: boolean;
    contacts: boolean;
    monetization: boolean;
    demoLogin: boolean;
    createOpenChat: boolean;
    isLogEnabled: boolean;
    markGroupAsReadUnread: boolean;
    draftInput: boolean;
    feedback: boolean;
    stickerDeepLink: boolean;
    refreshDeepLink: boolean;
    isProxyEnabled: boolean;
    isDemoChatTtlOptionsEnabled: boolean;
  };

  imageAssets: {
    article: string;
    badge: string;
    bannerSpace: string;
    block: string;
    calls: string;
    channelCreation: string;
    collection: string;
    contacts: string;
    conversation: string;
    error: string;
    gift: string;
    help: string;
    mistake: string;
    newVersion: string;
    news: string;
    notFound: string;
    onlineShop: string;
    plans: string;
    savedMessages: string;
    sharedData: string;
    sharing: string;
    space1: string;
    space2: string;
    space3: string;
    space4: string;
    stickerBackground: string;
    stickerSonfetti: string;
    underMaintenance: string;
    mainBackgroundDark: string;
    mainBackgroundLight: string;
    mainBackgroundLogoLight: string;
    mainBackgroundLogoDark: string;
    mainLogoLight: string;
    mainLogoDark: string;
    previewLogoLight: string;
    previewLogoDark: string;
    calendarLight: string;
    calendarDark: string;
    callInvitaion: string;
  };

  brandColor: string;
  mode: 'production' | 'development';
  projectName: string;
  ogDescription: string;

  supportEmail: string;
  amplitudeApiKey: string;
  reCaptchaKey: string;
  gtmId: string;
  deeplinkHost: string;
  deeplinkHostNew: string;
  deeplinkNativePath: string;
  language?: string;
  availableLaungages: AppLanguage[];

  proxyUrls?: Partial<IProjectConfigUrls>;
}
